// extracted by mini-css-extract-plugin
export var table = "_ts-0";